import { Link } from "@whitespace/components";
import { Action } from "@whitespace/gatsby-theme-smorgasbord/src/components";
import useModal from "@whitespace/gatsby-theme-smorgasbord/src/hooks/useModal";
import { format, parseISO } from "date-fns";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import AptusContext from "../contexts/aptusContext";

export default function NextBookablePassAction() {
  const { t } = useTranslation();
  const { nextBookablePass } = useContext(AptusContext);
  const { showModal, Modal } = useModal();

  // @TODO nextBookablePass needs to come from the API
  if (!nextBookablePass) return null;

  const timestamp = parseISO(nextBookablePass.startTime);
  const heading = `${format(timestamp, "d MMMM")}, klockan ${format(
    timestamp,
    "kk:mm",
  )}, ${nextBookablePass.groupName}`;

  return (
    <Action label={t("bookNextAvailableTime")} heading={heading}>
      <Link onClick={showModal}>{t("book")}</Link>
      <Modal>
        <div>Book it!</div>
      </Modal>
    </Action>
  );
}
